<template>
    <stats-card :title="title"
                :type="'gradient-'+type"
                :sub-title="subscriptionAmount.toString()"
                :icon="showHeader ? '' : 'fad fa-chart-pie'"
                :loading="loading"
                class="mb-4 mb-xl-0">
        <template v-slot:header v-if="showHeader">
            <router-link :to="{ name: 'Rechnungen' }" class="router-link">
                <div class="row align-items-center">
                    <div class="col">
                        <h6 class="text-uppercase text-muted ls-1 mb-1">CRM</h6>
                    </div>
                    <div class="col-auto">
                        <div class="icon icon-shape"><i class="fad fa-balance-scale text-danger" aria-hidden="true"></i></div>
                    </div>
                </div>
            </router-link>
            <hr class="mb-3 mt-1">
        </template>
        <span v-if="error.length > 0" class="alert-inner--text"><strong>Fehler!</strong>  {{ error }}</span>
        <template v-slot:footer></template>
    </stats-card>
</template>
<script>
import {ref, watch, onMounted} from 'vue';
import UserService from '@/services/user.service';
import moment from 'moment';

export default {
    name: 'InvoiceSubscription',
    components: {},
    props: {
        type: {
            type: String,
            default: "info"
        },
        title: {
            type: String,
            default: "Restbestand DL-Abo"
        },
        showHeader: {
            type: Boolean,
            default: false
        }
    },
    setup() {

        const error = ref('');
        const loading = ref(false);

        function getError(request) {
            if (request.response && request.response.status == '401') {
                error.value = 'you are not logged in!';
            } else if (request.response && request.response.status == '403') {
                error.value = 'you are not permitted!';
            } else {
                error.value = ""
            }
        }

        const subscriptions = ref([]);
        const subscriptionAmount = ref(0.0);
        subscriptionAmount.value = 0.0.toLocaleString('de-CH', {
            style: 'currency',
            currency: 'CHF'
        });

        watch(subscriptions, () => {
            subscriptionAmount.value = subscriptions.value.reduce((partialSum, a) => partialSum + a.amountCreditRemaining, 0).toLocaleString('de-CH', {
                style: 'currency',
                currency: 'CHF'
            });
        });

        function getSubscription() {
            loading.value = true;
            UserService.getSubscription().then(
                response => {
                    subscriptions.value = response.data.data;
                    error.value = '';
                    loading.value = false;
                },
                error => {
                    getError(error);
                    loading.value = false;
                }
            );
        }

        onMounted(() => {
            getSubscription();
        });

        return {
            error,
            subscriptionAmount,
            loading,
        }
    }
}
</script>

<style lang="scss">
:root {
    --ck-border-radius: 0.375rem;
}
</style>
